(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["infinity-gallery"] && !Shopify.designMode) return;
  try {
    
$(document).ready(function(){
  $('.autoplay').each(function(){ // This will initialize every carousel on the page
    $(this).slick({
      infinite: true,
      slidesToShow: 5, // Match this with the number of items you want to show based on CSS changes
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 2000,
      nextArrow: '<button type="button" class="slick-next">&gt;</button>',
      prevArrow: '<button type="button" class="slick-prev">&lt;</button>',
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 4, // You can adjust this for different screen sizes
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1, // Adjust for smaller screens
            slidesToScroll: 1
          }
        }
      ]
    });
  });
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
    var tag = document.createElement('script');
    tag.src = "https://www.youtube.com/iframe_api";
    var firstScriptTag = document.getElementsByTagName('script')[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

    window.onYouTubeIframeAPIReady = function() {
        document.querySelectorAll('.js-youtube').forEach((iframe) => {
            var player = new YT.Player(iframe, {
                events: {
                    'onError': function(event) {
                        if (event.data === 150 || event.data === 101) {
                            // Error 150 or 101, video not available. Try reloading.
                            console.log('Attempting to reload video due to error ' + event.data);
                            player.stopVideo();
                            player.playVideo();
                        }
                    }
                }
            });
        });
    };
});

  } catch(e) { console.error(e); }
})();
})();
